import ibanLib from 'iban';
import { useFormContext } from 'react-hook-form';

import { FormSectionWrapper } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Loan/PaymentIntent/Multilender/MerchantPos/MerchantPosForm/components/_shared/FormSectionWrapper';
import { FormGridContainer } from '@/components/shared/components/FormGridContainer/FormGridContainer';
import { FormGridOptions } from '@/components/shared/components/FormGridContainer/types/formGridOptions';
import { TextFormField } from '@/components/shared/components/NewContextForms/TextFormField';

interface BankAccountFormProps extends FormGridOptions {}

export const BankAccountForm = ({ fieldVariant, fullWidth, direction }: BankAccountFormProps) => {
  const { setValue } = useFormContext();

  const handleChange = (event) => {
    const inputValue = event.target.value;
    const formattedIban = ibanLib.printFormat(inputValue);
    setValue('bankAccountNumber', formattedIban); // Update the form value
  };

  return (
    <FormSectionWrapper titleTid={'ACCOUNT_NUMBER'} subtitleTid={'BANK_ACCOUNT_FORM_INFO'}>
      <FormGridContainer fieldVariant={fieldVariant} fullWidth={fullWidth} direction={direction}>
        <TextFormField
          name={'bankAccountNumber'}
          label={'IBAN'}
          InputProps={{
            onChange: handleChange,
          }}
          fieldVariant={fieldVariant}
        />
      </FormGridContainer>
    </FormSectionWrapper>
  );
};
